module.exports = __webpack_public_path__ + "media/images/user_placeholder-8665435f.png";